<template>
	<div>
    <div class="container">
		<!-- 搜索框 -->
		<div class="seach-container">
			<div class="flex flex-wrap justify-between">
				<!-- 用户名称 -->
				<div class="form-container">
					<div class="form-box-item">
						<div class="form-box-item-label">
						<span class="letterspance2">角色名称</span>
						</div>
						<div class="form-box-item-item">
						<el-input
							v-model="query.roleName"
							size="small"
							placeholder="请输入角色名称"
						></el-input>
						</div>
					</div>
				</div>
				<div class="form-container">
					<div class="form-box-item serch-operate2">
						<el-button type="primary" size="mini" icon="el-icon-search" @click="getTableData">搜索</el-button>
						<el-button  icon="el-icon-delete" size="mini" @click="onClearCondtionChange">清空</el-button>
					</div>
				</div>
			</div>
		</div>
		<!-- 操作 -->
		<div class="seach-container" style="padding: 0px 0px;">
			<div class="flex flex-wrap justify-between">
				<div class="form-container">
					<el-button style="margin-left: 6px;" type="primary" size="mini" icon="el-icon-plus" @click="handleAdd">新增</el-button>
				</div>
			</div>
		</div>
        <!--表格树内容栏-->
        <el-table :data="pageResult" :highlight-current-row="true" :max-height="scrollHeight" :border="true" :stripe="false" :show-overflow-tooltip="true">
          <el-table-column v-for="column in columns" header-align="center" align="center"
          :prop="column.prop" :label="column.label" :width="column.width" :min-width="column.minWidth" :key="column.prop" :type="column.type">
          </el-table-column>
          <el-table-column label="操作" width="350" header-align="center" align="center">
            <template #default="scope">
              <el-button icon="el-icon-coordinate" size="mini" type="info" @click="handleSetPerm(scope.$index, scope.row)">授权</el-button>
              <el-button icon="el-icon-edit" size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
              <!-- <el-button icon="el-icon-delete" size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :current-page="query.pageIndex"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="query.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="pageTotal">
            </el-pagination>
        </div>
    </div>

    <!--新增角色-->
		<el-dialog :title="'新增角色'" width="40%" v-model="dialogVisibleAdd" :close-on-click-modal="false">
			<el-form :model="dataForm" label-width="80px" :rules="dataFormRules" ref="dataForm" :size="size">
				<el-form-item label="ID" prop="RoleID" v-if="false">
					<el-input v-model="dataForm.RoleID" :disabled="true" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="角色名" prop="RoleName">
					<el-input v-model="dataForm.RoleName" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="备注 " prop="RoleDesc">
					<el-input v-model="dataForm.RoleDesc" auto-complete="off" type="textarea"></el-input>
				</el-form-item>
			</el-form>
			<div class="dialog-footer">
				<el-button :size="size" @click="dialogVisibleAdd = false">取消</el-button>
				<el-button :size="size" type="primary" @click="addRole">添加角色</el-button>
			</div>
		</el-dialog>

		<!--编辑角色-->
		<el-dialog :title="'编辑角色'" width="40%" v-model="dialogVisibleEdit" :close-on-click-modal="false">
			<el-form :model="dataForm" label-width="80px" :rules="dataFormRules" ref="dataForm" :size="size">
				<el-form-item label="ID" prop="RoleID" v-if="false">
					<el-input v-model="dataForm.RoleID" :disabled="true" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="角色名" prop="RoleName">
					<el-input v-model="dataForm.RoleName" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="备注 " prop="RoleDesc">
					<el-input v-model="dataForm.RoleDesc" auto-complete="off" type="textarea"></el-input>
				</el-form-item>
			</el-form>
			<div class="dialog-footer">
				<el-button :size="size" @click="dialogVisibleEdit = false">取消</el-button>
				<el-button :size="size" type="primary" @click="editRole">编辑角色</el-button>
			</div>
		</el-dialog>

		<!--设置角色权限-->
		<el-dialog :title="'《'+dataForm.RoleName+'》设置角色权限'" width="40%" v-model="dialogVisibleSet" :close-on-click-modal="false">
			<div class="menu-header">
				<span><b>菜单目录树</b></span>
			</div>
			<el-tree
				:data="menuData"
				show-checkbox
				node-key="MenuID"
				ref="menuTree" 
				:render-content="renderContent"
				:default-checked-keys="checkedMenus"
				:props="defaultProps"
				@check-change="handleMenuCheckChange"
			/>
			<div style="padding:10px;">
				<el-checkbox v-model="checkAll" @change="handleCheckAll"><b>全选</b></el-checkbox>
			</div>
			<div class="dialog-footer">
				<el-button
					size="small"
					type="primary"
					@click="resetSelection()"
					icon="el-icon-platform-eleme">取消</el-button>
				<el-button
					size="small"
					type="primary"
					@click="submitAuthForm()"
					icon="el-icon-platform-eleme">授权</el-button>
			</div>
		</el-dialog>
    </div>
</template>

<script>
  import indexJs from "./index.js";
  export default indexJs;
</script>

<style scoped>
@import url(./assets/style/style.less);
</style>
